import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-bill-of-supply',
  templateUrl: './bill-of-supply.component.html',
  styleUrls: ['./bill-of-supply.component.css']
})
export class BillOfSupplyComponent implements OnInit {

    @Input() data: any;
    @Input() isReceipt: boolean = false;
    rideId: any;
    invoiceNumber: any;
    invoiceDate: any;
    state: any;
    riderTaxCategory: any;
    placeOfSupply: any;
    gstTin: any;
    captainName: any;
    bikeNumber: any;
    customerName: any;
    pickupLocationAddress: any;
    dropLocationAddress: any;
    modeOfVehicle: any;
    timeOfRide: any;
    selectedPrice: string;
    captainFee: string;
    total: string | number;
    gst: string;
    service: string;
    merchantName: string;
    merchantAddress: string;
    merchantGstNumber: string;
    isCorporateOrder: boolean;
    clientName: string;
    cgst: string;
    cgstVal: string;
    sgst: string;
    igst: string;
    sgstVal: string;
    igstVal: string;

    constructor() { }

    ngOnInit() {
        this.formatData();
    }

    getPercentage = (val: any) => {
        return Number(Number(val * 100).toFixed(2));
    }

    formatData = () => {
        const data = this.data;
        if (this.isReceipt) {
            this.rideId = data.receiptNumber || data.rideId || data.orderId || '';
        } else {
            let rawRideId = data.rideId || data.orderId || '';
            if (rawRideId && !rawRideId.startsWith('RD')) {
                this.rideId = 'RD' + rawRideId;
            } else {
                this.rideId = rawRideId;
            }
        }
        this.invoiceNumber = data.invoiceNumber || data.receiptNumber || '';
        this.invoiceDate = data.invoiceDate || data.date || '';
        this.state = data.state || '';
        this.riderTaxCategory = data.riderTaxCategory || '';
        this.placeOfSupply = data.placeOfSupply || '';
        this.gstTin = data.gstTin || '';
        this.captainName = data.captainName || '';
        this.bikeNumber = data.bikeNumber || '';
        this.customerName = data.customerName || '';
        this.pickupLocationAddress = data.pickupLocationAddress || '';
        this.dropLocationAddress = data.dropLocationAddress || data.dropLocation || '';
        this.modeOfVehicle = data.modeOfVehicle || data.vehicleMode || data.mode || data.service || '';
        
        if (this.isReceipt) {
            const dateStr = data.date || '';
            const timeStr = data.receiptTime || '';
            if (dateStr && timeStr) {
                this.timeOfRide = `${dateStr}, ${timeStr}`;
            } else if (dateStr) {
                this.timeOfRide = dateStr;
            } else if (timeStr) {
                this.timeOfRide = timeStr;
            } else {
                const timeOfRideRaw = data.timeOfRide || data.tripDate || '';
                if (timeOfRideRaw) {
                    const date = moment(timeOfRideRaw);
                    if (date.isValid()) {
                        const day = date.date();
                        const daySuffix = this.getDaySuffix(day);
                        const month = date.format('MMM');
                        const year = date.format('YYYY');
                        const time = date.format('h:mm A');
                        this.timeOfRide = `${month} ${day}${daySuffix} ${year}, ${time}`;
                    } else {
                        this.timeOfRide = timeOfRideRaw;
                    }
                } else {
                    this.timeOfRide = '';
                }
            }
        } else {
            const timeOfRideRaw = data.timeOfRide || data.tripDate || data.date || '';
            if (timeOfRideRaw) {
                const date = moment(timeOfRideRaw);
                if (date.isValid()) {
                    const day = date.date();
                    const daySuffix = this.getDaySuffix(day);
                    const month = date.format('MMM');
                    const year = date.format('YYYY');
                    const time = date.format('h:mm A');
                    this.timeOfRide = `${month} ${day}${daySuffix} ${year}, ${time}`;
                } else {
                    this.timeOfRide = timeOfRideRaw;
                }
            } else {
                this.timeOfRide = '';
            }
        }
        
        if (data.riderCharge) {
            const withoutTax = data.riderCharge.withoutTax !== undefined ? data.riderCharge.withoutTax : (data.riderCharge.total || 0);
            this.captainFee = `₹ ${Number(withoutTax).toFixed(2)}`;
            this.total = `₹ ${Number(data.riderCharge.total || 0).toFixed(2)}`;
        } else {
            this.captainFee = '₹ 0.00';
            const totalAmount = data.finalAmount !== undefined ? data.finalAmount : (data.amount !== undefined ? data.amount : 0);
            this.total = `₹ ${Number(totalAmount).toFixed(2)}`;
        }
        
        if (this.isReceipt && data.finalAmount !== undefined) {
            this.total = `₹ ${Number(data.finalAmount).toFixed(2)}`;
            this.selectedPrice = `₹ ${Number(data.finalAmount).toFixed(2)}`;
        } else if (this.isReceipt) {
            this.selectedPrice = this.total;
        } else {
            this.selectedPrice = '';
        }

        if (data.tax && data.tax.captain) {
            this.cgst = `(${this.getPercentage(data.tax.captain.cgst)}%)`;
            this.sgst = `(${this.getPercentage(data.tax.captain.sgst)}%)`;
            this.igst = `(${this.getPercentage(data.tax.captain.igst)}%)`;
        } else {
            this.cgst = '(0%)';
            this.sgst = '(0%)';
            this.igst = '(0%)';
        }
        
        if (data.riderCharge) {
            this.cgstVal = data.riderCharge.cgst !== undefined ? `₹ ${Number(data.riderCharge.cgst).toFixed(2)}` : '₹ 0.00';
            this.sgstVal = data.riderCharge.sgst !== undefined ? `₹ ${Number(data.riderCharge.sgst).toFixed(2)}` : '₹ 0.00';
            this.igstVal = data.riderCharge.igst !== undefined ? `₹ ${Number(data.riderCharge.igst).toFixed(2)}` : '₹ 0.00';
        } else {
            this.cgstVal = '₹ 0.00';
            this.sgstVal = '₹ 0.00';
            this.igstVal = '₹ 0.00';
        }

        this.gst = '₹ 0.00';
        this.service = data.service ? data.service.toLowerCase() : 'ride';
        this.merchantName = data.merchantName || '';
        this.merchantAddress = data.merchantAddress || '';
        this.merchantGstNumber = data.merchantGstNumber || '';
        this.isCorporateOrder = data.isCorporateOrder || false;
        this.clientName = data.clientName || '';
    }

    getDaySuffix = (day: number): string => {
        if (day >= 11 && day <= 13) {
            return 'th';
        }
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }
}